import { createLink, LinkComponent } from "@tanstack/react-router";
import { Button } from "../ui/button";

const CreatedLinkComponent = createLink(Button);

export const RouterButton: LinkComponent<typeof Button> = (props) => (
	<CreatedLinkComponent variant="soft" {...props} />
);
